import styled from 'styled-components';

import { viewportMaxCss } from '../shared/playable.style';

type InteractiveResponseContainerProps = {
  $isLoading?: boolean;
};
export const InteractiveResponseContainer = styled.div<
  InteractiveResponseContainerProps
>`
  ${viewportMaxCss}
  opacity: ${props => (props.$isLoading ? 0.2 : 1)};
  transition: opacity 300ms ease-in-out;
  position: relative;
  width: 100%;
`;
